export default "__VITE_ASSET__873af08f__"